/* Closing band.

   The product shot is deliberately cropped by the bottom of the band — you're
   meant to feel there's more below. That only works if content runs all the way
   to the cut; previously the panels ran out of content ~150px early, so the
   crop landed in white space and read as a rendering bug rather than a peek.

   Every panel now fills to the edge, the chart is labelled (bars with no axis
   are decoration, not evidence), and the headline has support beneath it
   instead of sitting alone in a very large band. */

const DAYS = [
  { d: 'Mon', h: 52 },
  { d: 'Tue', h: 68 },
  { d: 'Wed', h: 61 },
  { d: 'Thu', h: 84, peak: true },
  { d: 'Fri', h: 73 },
  { d: 'Sat', h: 24, off: true },
  { d: 'Sun', h: 14, off: true },
];

const TEAMS = ['Engineering', 'Design', 'Sales', 'Support', 'Marketing'];

const FLAGS = [
  { t: 'Leave pattern', d: 'every 7th working day', tone: 'amber' },
  { t: 'After-hours', d: '3× baseline, Marketing', tone: 'red' },
  { t: 'Reply lag', d: 'client emails, 3+ days', tone: 'blue' },
  { t: 'Meeting load', d: 'Ops at 41% of the week', tone: 'amber' },
  { t: 'Deep focus', d: 'up 14% since Wednesday', tone: 'green' },
];

const PROOF = ['7-day free trial', 'No credit card', 'Live in 5 minutes'];

export default function FinalCta() {
  return (
    <section className="final" id="s-cta">
      <div className="container-wide">
        <div className="final-band">
          <h2>All your work, all your people,<br />all understood</h2>
          <p className="final-sub">
            One agent, every team, one brain reading the patterns. Set it up this morning —
            your first real answer lands before the day is out.
          </p>

          <a className="btn-white" href="/register">Get started FREE</a>

          <ul className="final-proof">
            {PROOF.map((p) => (
              <li key={p}>
                <svg aria-hidden="true" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
                {p}
              </li>
            ))}
          </ul>

          <div className="final-shot" aria-hidden="true">
            <div className="fs-top">
              <span className="fs-dots"><i style={{ background: '#ff5f57' }} /><i style={{ background: '#febc2e' }} /><i style={{ background: '#28c840' }} /></span>
              <span className="fs-ws">Arclight — Pulse</span>
              <span className="fs-search">⌕ Ask TeamGrid anything…</span>
              <span className="fs-live"><i />LIVE</span>
            </div>

            <div className="fs-body">
              <div className="fs-side">
                <div className="fs-lab">TEAMS</div>
                {TEAMS.map((t, i) => (
                  <div key={t} className={`fs-team${i === 0 ? ' on' : ''}`}>
                    {t}<span>{[34, 12, 21, 16, 9][i]}</span>
                  </div>
                ))}
                <div className="fs-side-foot">5 teams · 92 people<br />1 agent on every machine</div>
              </div>

              <div className="fs-main">
                <div className="fs-head">
                  <span className="fs-title">Team pulse — this week</span>
                  <span className="fs-delta">+12% vs last week</span>
                </div>
                <div className="fs-big">38.4<small>h focused per person</small></div>

                <div className="fs-chart">
                  {DAYS.map((d) => (
                    <span key={d.d} className={`fs-bar${d.peak ? ' peak' : ''}${d.off ? ' off' : ''}`}>
                      <i style={{ height: `${d.h}%` }} />
                      <em>{d.d}</em>
                    </span>
                  ))}
                </div>

                <div className="fs-metrics">
                  <div className="fs-metric">
                    <span className="fs-mlab">Deep focus<b>71%</b></span>
                    <span className="fs-mbar"><i style={{ width: '71%', background: '#6C59A6' }} /></span>
                  </div>
                  <div className="fs-metric">
                    <span className="fs-mlab">After-hours<b>38%</b></span>
                    <span className="fs-mbar"><i style={{ width: '38%', background: '#F2673A' }} /></span>
                  </div>
                  <div className="fs-metric">
                    <span className="fs-mlab">On-time hand-offs<b>86%</b></span>
                    <span className="fs-mbar"><i style={{ width: '86%', background: '#2DBDB8' }} /></span>
                  </div>
                </div>
              </div>

              <div className="fs-feed">
                <div className="fs-lab">ANOMALY FEED<span className="fs-count">5</span></div>
                {FLAGS.map((f) => (
                  <div key={f.t} className={`fs-flag ${f.tone}`}>
                    <b>{f.t}</b> — {f.d}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <p className="final-note">
          Zero data training &amp; retention agreements are in place with every model provider.
          Patterns, not people — no screenshots, no keystrokes, ever.
        </p>
      </div>
    </section>
  );
}
